import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3" }
const _hoisted_2 = {
  tabindex: "0",
  class: "draggable-card w-full flex items-center justify-between cursor-grab shadow-lg h-full bg-white rounded-md border-2 border-gray-200 p-2 px-3 min-h-15"
}
const _hoisted_3 = { class: "text-sm truncate" }
const _hoisted_4 = { class: "truncate text-sm font-medium text-gray-800" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "text-brand-500 font-medium truncate"
}
const _hoisted_7 = {
  key: 1,
  class: "text-brand-500 font-medium truncate"
}
const _hoisted_8 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_9 = {
  key: 3,
  class: "text-gray-400 truncate text-xs"
}
const _hoisted_10 = {
  key: 4,
  class: "text-gray-400 truncate text-xs"
}

import { 
		Draggable 
	} from 'vue3-smooth-dnd'

	// Languages
	import { 
		useI18n
	} from 'vue-i18n'

	// Store
	import {
		useSceneEditorStore
	} from '@/store/sceneEditor'

	// Vue
	

	
	const __default__ = { name: 'SceneCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		i: {
			type: Number,
			default: 0
		},
		loading: {
			type: Boolean,
			default: false
		},
		scene: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	// Drag n drop
	const props = __props

	const {t} = useI18n()
	const sceneEditorStore = useSceneEditorStore()

	/**
	 * Removes the selected scene from the scene editor store
	 * @function removeScene
	 */
	function removeScene() {
		sceneEditorStore.sceneEditor.scenes.splice(props.i, 1)
	}


return (_ctx: any,_cache: any) => {
  const _component_StarIconMini = _resolveComponent("StarIconMini")!

  return (_openBlock(), _createBlock(_unref(Draggable), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.i + 1) + ". " + _toDisplayString(__props.scene['job__job_scene__SCENES__sceneID::name_display']), 1),
            (Boolean(__props.scene['job__JOBS_SCENES__jobID::main_scene']))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (__props.scene['job__job_scene__job_song__SONGS__songID::name_display']?.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.scene['job__job_scene__job_song__SONGS__songID::name_display']), 1))
                    : (__props.scene['job__JOBS_SCENES__jobID::customSongName']?.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.scene['job__JOBS_SCENES__jobID::customSongName']), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('sceneEditor.missingSong')), 1)),
                  (__props.scene['job__job_scene__job_song__songs__ARTISTS__artistID::artist_display']?.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.scene['job__job_scene__job_song__songs__ARTISTS__artistID::artist_display']), 1))
                    : _createCommentVNode("", true),
                  (__props.scene['job__JOBS_SCENES__jobID::customSongArtist']?.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.scene['job__JOBS_SCENES__jobID::customSongArtist']), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (Boolean(__props.scene['job__JOBS_SCENES__jobID::main_scene']))
            ? (_openBlock(), _createBlock(_component_StarIconMini, {
                key: 0,
                class: "h-4 w-4 text-brand-500"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "text-sm remove-button cursor-default whitespace-nowrap",
          onClick: removeScene
        }, _toDisplayString(_unref(t)('sceneEditor.remove')), 1)
      ])
    ]),
    _: 1
  }))
}
}

})